import { useState } from "react";

import { FeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { m } from "@vega-core/paraglide/messages";
import { isGPCoInvestPortal } from "@vega-core/utils/global";
import { useFeatureFlagGuard } from "@vega-modules/hooks/useFeatureFlagGuard";
import { CoInvestmentFullPaths, CommonPaths } from "@vega-modules/paths";
import { ConversationsList } from "@vega-modules/scenes/CoInvestments/messaging/ConversationsList";

import { CoInvestmentPageHeader } from "../components/CoInvestmentPageHeader/CoInvestmentPageHeader";
import { NotificationsDealFilterDropdown } from "../components/NotificationsDealFilterDropdown/NotificationsDealFilterDropdown";

export const CoInvestMessagesPage = () => {
  useFeatureFlagGuard(
    FeatureFlag.COINVEST_MESSAGING_VD_28584,
    isGPCoInvestPortal ? undefined : CommonPaths.Home,
  );

  const [dealId, setDealId] = useState<string>();

  return (
    <div className="mt-1 pb-52">
      <CoInvestmentPageHeader
        description={m.coInvestments_messages_subtitle()}
        showDrawer={false}
        title={m.coInvestments_messages_title()}
      />

      <div className="flex flex-col gap-6">
        <NotificationsDealFilterDropdown onChange={setDealId} value={dealId} />

        <ConversationsList
          buildConversationPath={(conversation) =>
            CoInvestmentFullPaths.CoInvestmentConversation.replace(
              ":conversationId",
              conversation.id,
            )
          }
          buildItemTestId={(conversation) =>
            `coinvest-conversation-${conversation.id}`
          }
          errorTestId="coinvest-messages-error"
          getParticipantName={(conversation) =>
            conversation.meta.limitedPartnerName
          }
          listTestId="coinvest-messages-list"
          metaFilter={dealId ? { dealId } : undefined}
        />
      </div>
    </div>
  );
};
